"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComputedProvider = void 0;
const ramda_1 = require("ramda");
const provider_1 = require("./provider");
class ComputedProvider extends provider_1.BaseProvider {
    static create(compute) {
        return new ComputedProvider({ compute });
    }
    merge(props) {
        return new ComputedProvider({ ...this.props, ...props });
    }
    async evaluate({ ctx }) {
        const { compute = () => undefined } = this.props;
        return [ctx.path, compute(ctx.root, ctx.path)];
    }
    getPropsToLog() {
        return (0, ramda_1.dissoc)("compute", this.props);
    }
}
exports.ComputedProvider = ComputedProvider;
